import React from 'react'
import styles from '../ModulosPagoTienda/stylesPagoTienda.module.sass'
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import { MenuCredito } from 'components/menuCredito'
import { FormasPagoTienda, PagoTiendaPrint } from '../ModulosPagoTienda'

export default function PagoTiendaDesktop(props) {
    const {
        payCard,
        barCode,
        idClaro,
        handleImprimir,
        isMobile
    } = props

    return (
        <>
            <Header type="complete" />

            <div className={`container no-printme ${styles?.no_printme}`}>
                <div className={styles?.contCards}>

                    <MenuCredito />

                    <div className={styles?.contArrayCards}>

                        <FormasPagoTienda
                            payCard={payCard}
                            barCode={barCode}
                            idClaro={idClaro}
                            handleImprimir={handleImprimir}
                            isMobile={isMobile}
                        />

                    </div>
                </div>
            </div>

            <Footer type="complete" />

            <PagoTiendaPrint
                payCard={payCard}
                barCode={barCode}
                idClaro={idClaro}
            />
        </>
    )
}